import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
// @mui
import { Alert, Container, Stack, ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';
import api from 'src/utils/api';
// components
import { CourseList } from '../../sections/@dashboard/courses';
/* // mock
import PRODUCTS from '../../_mock/courses'; */

// ----------------------------------------------------------------------

export default function CoursesPage() {
  const [courses, setCourse] = useState([]);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    api.get(`course-api?filter[level]=${tab}`)
      .then((result) => {
        setCourse(result);
      })
      .catch(() => {
        setCourse([]);
      });
  }, [tab])

  return (
    <>
      <Helmet>
        <title> Курси | Lala English </title>
      </Helmet>

      <Alert severity="error" sx={{ mb: 5, pl: 3 }}>Перелік доступних вам курсів.</Alert>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <ToggleButtonGroup
            value={tab}
            exclusive
            onChange={(_, value) => setTab(value)}
          >
            <ToggleButton value={0}>
              <Typography>Base</Typography>
            </ToggleButton>
            <ToggleButton value={1}>
              <Typography>Classic</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>
        <CourseList courses={courses} />
      </Container>
    </>
  );
}
